<mat-form-field class="search" [appearance]="appearance" [class.form-field-sm]="isSmall">
  <mat-label>{{label}}</mat-label>
  <mat-icon matPrefix class="search-icon">search</mat-icon>
  <input matInput [placeholder]="placeholder" [(ngModel)]="searchText" [matAutocomplete]="auto" [formControl]="myControl">
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option" class="search" (onSelectionChange)="selectItem(option)">
      {{option}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>